import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-room-type',
	templateUrl: './room-type.component.html',
	styleUrls: ['./room-type.component.css'],
})
export class RoomTypeComponent extends ShowComponent {
	protected apiType = 'bag';
	protected apiUrlAdd = '/product/room/type/?limit=9999';
	protected parentComponent = 'codebook/room_type';
	beds: Array<any> = [];
	codebook;
	roomKind = [
		{ kind: 'S', name: 'Studio' },
		{ kind: 'A', name: 'Apartament' },
		{ kind: 'R', name: 'Pokój' },
	];

	data = {
		id: null,
		name: '',
		code: null,
		kind: null,
		configurations: [],
	};

	protected pageTitleGenerate(): string {
		return `Słowniki -> 
			${this.codebook.name}
			 -> 
			${this.data.name}
			(ID:
			${this.data.id}
			)`;
	}

	protected loadBefore(): void {
		this.bag.get('/product/bed_configuration/', (result, error) => {
			this.beds = result.results.map((element) => {
				if (element.maxAge === null) {
					element.maxAge = 'None';
				}
				if (element.kind === 'S') {
					element.kind = 'Pojedyńcze';
				} else if (element.kind === 'D') {
					element.kind = 'Małżeńskie';
				} else if (element.kind === 'E') {
					element.kind = 'Extra';
				}
				return element;
			});
		});

		this.bag.get('/codebook/2/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}

	protected submitAfter(): void {
		this.router.navigate([this.parentComponent]);
	}

	protected convertData(data) {
		data.configurations = data.configurations.map((obj) => {
			return obj.id;
		});
		return data;
	}

	protected getApiUrl(): string {
		return '/product/room/type/' + this.data.id + '/';
	}
}
